import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M43.691667,45.15 L50.691667,61 L44.291667,61 L38.291667,47 L33.591667,47 L33.591667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 43.691667,45.15 Z M33.591667,42.2 L39.241667,42.2 C42.791667,42.2 44.691667,40.85 44.691667,37.95 C44.691667,35.05 42.791667,33.8 39.241667,33.8 L33.591667,33.8 L33.591667,42.2 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
